import Api from 'api/api';

class OrderApi {
    getISV(harborId: string, amount: number) {
        return Api.get(`/public/kiosk/order/${harborId}/isv?amount=${amount}`);
    }
}

export default new OrderApi();
